module.exports = __webpack_public_path__ + "img/speedometer.9947e8ce.svg";